import requestBuilder from '@/services/graphql/requestBuilder';
import { ASYNC_SEARCH_RESULT } from '../fragments';
import {
  SEARCH_COMMUNITY_PRODUCTS_V3, SEARCH_PRODUCTS_V3, SEARCH_PRODUCT_REF_V3,
} from '@/constants/searching/searchingAsyncV2';
export default {
  asyncCommunityProductsV3(variables) {
    return new requestBuilder({
      requestName: SEARCH_COMMUNITY_PRODUCTS_V3,
      requestVariables: {
        filters: 'searchFilters',
        limit: 'Int',
        query: 'String',
        requestId: 'String',
        scrollID: 'String',
        workspaceId: 'String',
      },
      response: ASYNC_SEARCH_RESULT,
      variables,
    }).processRequest();
  },
  asyncProductsV3(variables) {
    return new requestBuilder({
      requestName: SEARCH_PRODUCTS_V3,
      requestVariables: {
        filters: 'searchFilters',
        followedOnly: 'Boolean',
        libraryId: 'String',
        limit: 'Int',
        myCollections: 'Boolean',
        pageId: 'String',
        query: 'String',
        requestId: 'String',
        scrollID: 'String',
        workspaceId: 'String',
      },
      response: ASYNC_SEARCH_RESULT,
      variables,
    }).processRequest();
  },
  asyncSearchProductRefV3(variables) {
    return new requestBuilder({
      requestName: SEARCH_PRODUCT_REF_V3,
      requestVariables: {
        limit: 'Int',
        projectId: 'String',
        query: 'String',
        requestId: 'String',
        scrollID: 'String',
        workspaceId: 'String!',
      },
      response: ASYNC_SEARCH_RESULT,
      variables,
    }).processRequest();
  },
};
